import Loadable from 'react-loadable'

import MainLayout from '../../components/layout/MainLayout'
import LoadingPage from '../../components/layout/Loading'


const PageMain = Loadable({
  loader: () => import('../../pages/authors/List_auth'),
  loading: LoadingPage,
})

const PageAction = Loadable({
  loader: () => import('../../pages/authors/Action'),
  loading: LoadingPage,
})

const Routes = [
  {
    path: '/admin/authors',
    exact: true,
    requiredAuth: true,
    component: PageMain,
    layout: MainLayout,
  },
  {
    path: '/admin/authors/action',
    exact: true,
    requiredAuth: true,
    component: PageAction,
    layout: MainLayout,
  },
  {
    path: '/admin/authors/action/:id',
    exact: true,
    requiredAuth: true,
    component: PageAction,
    layout: MainLayout,
  },
]

export default Routes
